/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastseentoday2Inputs */



/**
* | output |
* | --- |
* | "last seen: today" |
*
* @param {Lastseentoday2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const lastseentoday2 = /** @type {((inputs?: Lastseentoday2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastseentoday2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("last seen: today")
	if (locale === "es") return /** @type {LocalizedString} */ ("últ. vez: hoy")
	return /** @type {LocalizedString} */ ("в сети: сегодня")
});
export { lastseentoday2 as "lastSeenToday" }